import ReassignManagerForm from './ReassignManagerForm';

export default ReassignManagerForm;
